<template>
    <div />
</template>

<script>
import data from '@emoji-mart/data';
import { Picker } from 'emoji-mart';

export default {
    data() {
        return {
            picker: null,
        };
    },

    created() {
        this.picker = new Picker({
            data,
            onEmojiSelect: this.handleEmojiSelect,
            onClickOutside: this.handleClickOutside,
            theme: 'light',
            autoFocus: true,
        });
    },

    mounted() {
        this.$el.appendChild(this.picker);
    },

    methods: {
        handleEmojiSelect(selection) {
            this.$emit('select', selection);
        },

        handleClickOutside() {
            this.$emit('click-outside');
        },
    },
};
</script>
